import { pushEventInfo } from '../analytics';
// 1.1 Edit Pickup Person Overlay
export var catchEditPickupPersonButtonPress = function () {
    pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: {
            eventName: 'purchase history: order details: edit pickup person',
        },
    });
};
// 1.3 Order Details Pickup Person Updated
export var catchEditPickupPersonSuccess = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: edit pickup person updated',
        },
    });
};
// 1.4 Post Page Load Error Tracking
export var catchEditPickupPersonPostPageLoadError = function (errorCode) {
    pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'advisory',
                    displayType: 'inline',
                    pageSection: 'order details>edit pickup instructions',
                    message: 'Something went wrong on our end. Please check back later.',
                    code: errorCode,
                },
            ],
        },
    });
};
// 1.5 Order Details Pickup Person Updated Button Submission
export var catchButtonDisplayEvent = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'purchase history: order details: edit pickup person button displayed',
        },
    });
};
